import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VToolbar,{attrs:{"color":"transparent","flat":""}},[_c(VBtn,{staticClass:"mr-4",attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c(VIcon,[_vm._v(_vm._s(_vm.iconBackScreen))])],1),_c(VToolbarTitle,[_vm._v("Liquor License")])],1),_c('liquor-license',{attrs:{"company-id":_vm.userCompany.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }